import { render, staticRenderFns } from "./home-support.vue?vue&type=template&id=0da2e9f0&scoped=true"
var script = {}
import style0 from "./home-support.vue?vue&type=style&index=0&id=0da2e9f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da2e9f0",
  null
  
)

export default component.exports